import { PrimitiveType } from './Primitive';

export type FhirResourceParserSupportedTypes =
  | fhir.Address
  | fhir.Annotation
  | fhir.CodeableConcept
  | fhir.Coding
  | fhir.Extension[]
  | fhir.dateTime
  | fhir.HumanName
  | fhir.Identifier
  | fhir.Identifier[]
  | PrimitiveType
  | fhir.Quantity
  | fhir.Range
  | fhir.Timing;

export type DisplayValue = string;

export type SortValue = string | number;

class BaseParser {
  getDisplayValue(
    fhirProperty:
      | FhirResourceParserSupportedTypes
      | FhirResourceParserSupportedTypes[],
  ): DisplayValue {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    return fhirProperty !== undefined ? String(fhirProperty) : null;
  }

  getDisplayValueList(
    fhirProperty:
      | FhirResourceParserSupportedTypes
      | FhirResourceParserSupportedTypes[],
  ): DisplayValue[] {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    return fhirProperty !== undefined ? [String(fhirProperty)] : null;
  }

  getSortValue(
    fhirProperty:
      | FhirResourceParserSupportedTypes
      | FhirResourceParserSupportedTypes[],
  ): SortValue {
    return this.getDisplayValue(fhirProperty);
  }
}

export default BaseParser;
